import { makeVar } from "@apollo/client";

const token = localStorage.getItem("cus-rib-token");

const tokenVar = makeVar(token);

export default tokenVar;
